import React from "react";

// Official PSS GROUP logo (white on transparent)
const Logo = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="https://customer-assets.emergentagent.com/job_flex-jobs-4/artifacts/u34790br_image.png"
        alt="PSS Group"
        className="h-11 w-auto object-contain"
      />
      <div className="hidden sm:flex flex-col leading-tight border-l border-white/20 pl-3">
        <span className="font-display text-sm font-semibold tracking-wide text-white">PSS PERSONNEL</span>
        <span className="text-[0.65rem] tracking-wide text-white/50">Sp. z o.o.</span>
      </div>
    </div>
  );
};

export default Logo;
